var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBoldBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9984C14.2083 13.9984 15.9985 12.2082 15.9985 9.99993C15.9985 7.79162 14.2083 6.00143 12 6.00143C9.79165 6.00143 8.00146 7.79162 8.00146 9.99993C8.00146 12.2082 9.79165 13.9984 12 13.9984Z",
    fill: "#374957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 7.42008C21.7164 4.89501 18.1897 0.658569 12 0.658569C5.81027 0.658569 2.28358 4.89501 0.733158 7.42008C-0.244386 9.00119 -0.244386 10.999 0.733158 12.5802C2.28358 15.1052 5.81027 19.3417 12 19.3417C18.1897 19.3417 21.7164 15.1052 23.2668 12.5802C24.2443 10.999 24.2443 9.00119 23.2668 7.42008ZM12 15.9979C8.68752 15.9979 6.0022 13.3126 6.0022 10.0001C6.0022 6.68764 8.68752 4.00233 12 4.00233C15.3124 4.00233 17.9978 6.68764 17.9978 10.0001C17.9944 13.3112 15.3111 15.9945 12 15.9979Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBoldBlack);
export default __webpack_public_path__ + "static/media/eyeBoldBlack.7369eeb5e7301406e1bff0de8ad803e4.svg";
export { ForwardRef as ReactComponent };